import { createItemsData } from '../../helpers/request-helpers'
import { HALApiService } from '../hal-api.service'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const currenciesService = new CachedService(entities.Orderadmin_Settings_Entity_Currency, '/currency', HALApiService, createItemsData)
